/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION : STYLES --------------- ++++++++++ */
export default theme => ({
    configuration: {
        // This is added to override back to default selectors from media query in commenting_styles.js
        // TODO: remove this and make more specific selector in commenting_styles, cause now it overrides all textAlign styles in commenting tab
        textAlign: 'initial',
        display: 'initial',
        '& .expandablesection': {
            marginTop: pxToEm(16),
            '&:first-child': {
                marginTop: 0
            }
        }
    }
});
